import React from 'react';
import Rater from 'react-rater';
import { WhitePanel } from '../';

const FullReview = ({ isMobile = false, sectionId, reviews, type }) => {
  const Review = type === 'lodge' ? LodgeReview : FlightReivew;
  return (
    <WhitePanel
      id={sectionId}
      className={`reviews-box fullReviewSection ${ isMobile ? 'd-block d-lg-none':'d-none d-lg-block'}`}
    >
      <h2>Reviews</h2>
      <ul className="recent-comments">
        {
          reviews.map(r => <Review data={r} key={r.review} />)
        }
      </ul>
    </WhitePanel>
  );
}

FullReview.defaultProps = {
  type: 'lodge',
};

const SideReview = ({ isMobile = false, fullReviewsSectionId, reviews, type }) => {
  const Review = type === 'lodge' ? LodgeReview : FlightReivew;
  return (
    <WhitePanel className={`reviews-box ${ isMobile ? 'd-block d-lg-none':'d-none d-lg-block'}`}>
      <h2>Recent Reviews
        <span><a href={fullReviewsSectionId}>See all</a></span>
      </h2>
      <ul className="recent-comments">
        {
          reviews.slice(0, 3).map(r => <Review data={r} key={r.review} />)
        }
      </ul>
    </WhitePanel>
  );
}

SideReview.defaultProps = {
  type: 'lodge',
};

function LodgeReview({ data: { reviewer, rating, review, lodge, place, url } }) {
  return (
    <li>
      {/* <div className="image">
        <img src="https://s3.amazonaws.com/honeyguide/assets/user-fallback.png" alt="" />
      </div> */}
      <div className="comment">
        <h5>{reviewer}</h5>
        <Rater total={5} rating={rating} interactive={false} />
        <p>{review}</p>
        <a href={url} target="_blank" rel="noreferrer noopener"><h6>{lodge}, {place}</h6></a>
      </div>
    </li>
  );
}

function FlightReivew(
  { data: { id, author: { name }, ratings: { rating }, comment }}
) {
  return (
    <li>
      {/* <div className="image">
        <img src="https://s3.amazonaws.com/honeyguide/assets/user-fallback.png" alt="" />
      </div> */}
      <div className="comment">
        <h5>{name}</h5>
        <Rater total={5} rating={rating} interactive={false} />
        <p>{comment}</p>
      </div>
    </li>
  );
}

export { FullReview, SideReview };


// WEBPACK FOOTER //
// ./src/components/StaticReviews/index.js